import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import { blogPosts, featuredPost } from '../../blogs/data/blogData';
import { categoryLabel } from '../ResourcesPage/resourcesData';

const detailHref = (post) => ROUTES.BLOG_DETAILS.replace(':slug', post.slug);

const ArticleRelatedSection = ({ currentSlug }) => {
    const related = [...blogPosts, featuredPost].filter(p => p.slug !== currentSlug).slice(0, 5);
    if (!related.length) return null;

    return (
        <section className="lp-article-related">
            <div className="lp-container" style={{ maxWidth: 1200 }}>
                <div className="head">
                    <div>
                        <div className="lp-pe-eyebrow">Keep reading</div>
                        <h2>More from Diligentsia</h2>
                    </div>
                    <Link to={ROUTES.BLOGS}>View all →</Link>
                </div>

                <div className="grid">
                    {related.map((post) => (
                        <div className="card" key={post.slug}>
                            <div className="img" style={{ backgroundImage: `url(${post.image})` }} />
                            <div className="body">
                                <span className="tag">{categoryLabel((post.category || [])[0])}</span>
                                <h3>{post.title}</h3>
                                <Link to={detailHref(post)}>Read →</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ArticleRelatedSection;
